import {Component, EventEmitter, forwardRef, ViewChild, Output} from '@angular/core';
import {ModelListener} from '../model-listener/model.listener';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {isEmpty} from 'lodash';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => AmountRangePickerComponent),
    multi: true
};

@Component({
    selector: 'bs-amountrangepicker',
    template: require('./amountrangepicker.template.html'),
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class AmountRangePickerComponent extends ModelListener {

    onChange: EventEmitter<any> = new EventEmitter<any>();
    onTouchedCallback: EventEmitter<any> = new EventEmitter<any>();

    private minAmount: number;
    private maxAmount: number;
    @Output()
    private onValueChanged = new EventEmitter();
    @ViewChild('minModel') minModel;
    @ViewChild('maxModel') maxModel;


    ngOnInit() {
        setTimeout(() => {
            this.writeValue(undefined);
            this.minModel.valueChanges.subscribe(value => {
                if (isEmpty(value)) {
                    value = null;
                }
                this.writeValue({
                    ...this._innerValue,
                    minAmount: value
                });
                if (this._innerValue.minAmount == null && this._innerValue.maxAmount == null) {
                    this.writeValue(undefined);
                }
            });
            this.maxModel.valueChanges.subscribe(value => {
                if (isEmpty(value)) {
                    value = null;
                }
                this.writeValue({
                    ...this._innerValue,
                    maxAmount: value
                });
                if (this._innerValue.minAmount == null && this._innerValue.maxAmount == null) {
                    this.writeValue(undefined);
                }
            })
        });
    }

    clearValues() {
        this.minAmount = undefined;
        this.maxAmount = undefined;
        this.onAmountChange();
    }

    writeValue(obj: any): void {
        if (obj) {
            super.writeValue(obj);
        } else {
            super.writeValue(undefined);
        }
    }

    onAmountBlur(min: boolean) {
        if (this.minAmount && this.maxAmount) {
            if (Number(this.minAmount) > Number(this.maxAmount)) {
                if (min) {
                    this.maxAmount = undefined;
                } else {
                    this.minAmount = undefined;
                }
            }
        }
        this.onAmountChange();
    }

    onAmountChange() {
        this.onValueChanged.emit(this.getValues());
    }

    getValues(): any {
        return {
            minAmount: this.minAmount,
            maxAmount: this.maxAmount,
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/amount/amountrangepicker.component.ts